import React from 'react';
import { IconButton } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { alpha, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import '../directories/directories.css';
import './playerStatistics.css';

export default function PlayerStatisticsLayout({ title, subtitle, onBack, actions, headerTour, children }) {
  const theme = useTheme();
  const { t } = useTranslation('players');
  const tokens = {
    panel: theme.palette.background.paper, ground: theme.palette.background.default,
    ink: theme.palette.text.primary, muted: theme.palette.text.secondary, green: theme.palette.primary.main,
    line: theme.palette.divider, tint: alpha(theme.palette.primary.main, .12), hover: theme.palette.action.hover,
    'on-accent': theme.palette.mode === 'dark' ? '#172b21' : '#ffffff',
  };
  return <div className="dr-page ps-page" data-theme={theme.palette.mode} style={Object.fromEntries(
    Object.entries(tokens).map(([key, fallback]) => [`--dr-${key}`, `var(--dv-${key}, ${fallback})`])
  )}>
    <header className="ps-heading" data-tour={headerTour}>
      <IconButton onClick={onBack} aria-label={t('notFound.back')}><ArrowBack /></IconButton>
      <div><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
      {actions && <div className="ps-actions">{actions}</div>}
    </header>
    {children}
  </div>;
}
